import { Activity } from '../activity';
import { isArray } from 'util';
import { ActivityTypeBuilder } from './activity-type.builder';
import { ActivityViewTypeBuilder } from './activity-view-type.builder';

export class ActivityBuilder {
  static fromJson(json) {
    return (json)
      ? new Activity(
        json.hash,
        json.name,
        ActivityTypeBuilder.fromJson(json.type),
        ActivityViewTypeBuilder.fromJson(json.viewType)
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ActivityBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/activity.builder.ts